module.exports = __webpack_public_path__ + "img/54_27.204c7fcc.png";